import type { IAuthUser } from '@/shared/types/auth-user'
import { getPermissions } from './permissions'
import type { AppAbility } from './permissions'
import { AbilityBuilder, createMongoAbility } from '@casl/ability'

export function defineAbilitiesFor(user: IAuthUser | null): AppAbility {
  const { can, rules } = new AbilityBuilder<AppAbility>(createMongoAbility)

  if (!user) return createMongoAbility<AppAbility>(rules)

  // The landing page must open for any signed-in user, even one whose roles
  // grant nothing else — otherwise `/` would bounce them to /forbidden.
  can('read', 'home')

  user.roles.forEach((role) => {
    getPermissions(role).forEach((permission) => {
      can(permission.action, permission.subject)
    })
  })

  return createMongoAbility<AppAbility>(rules)
}

export const ability = (user: IAuthUser | null) => defineAbilitiesFor(user)
